import reservationAPI from '@/services/API/reservation'
import customerAPI from '@/services/API/customer'
import inventoryAPI from '@/services/API/inventory'
import { Message } from 'element-ui';

function buildSearchAndFiltersParams(state){
  let params = {};
  // params.paging='no';
  params.orderBy = state.orderBy.orderName;
  params.direction = state.orderBy.direction;
  params.searchTerms = state.searchTerms;
  params.limit = state.limit;
  params.page = state.page;
  params.types = [];
  params.inventoryId = [];
  _.forEach(state.filters.inventories, (i) => {
    params.inventoryId.push(i.id);
  })

  params.customerClassId=[];
   _.forEach(state.filters.checkedCustomerClasses, c=>{
    params.customerClassId.push(c);
  })

  if (state.filters.active) params.types.push('active');
  if (state.filters.delayed) params.types.push('delayed');
  if (state.filters.intent) params.types.push('intent');
  if (state.filters.completed) params.types.push('completed');

  params.redFlag = state.filters.redFlag?state.filters.redFlag:undefined;
  params.yellowFlag = state.filters.yellowFlag?state.filters.yellowFlag:undefined;
  params.greenFlag = state.filters.greenFlag?state.filters.greenFlag:undefined;
  params.salesRep = state.filters.salesRep?state.filters.salesRep:undefined;
  params.customerId = state.filters.customerId?state.filters.customerId:undefined;
  params.productId = state.filters.productId?state.filters.productId:undefined;

 return params;
}

const getQueryParams = function({state}) {
  return buildSearchAndFiltersParams(state);
}


const fetchNextReservationsPage = function({commit, dispatch, state}){
  commit('SET_PAGE',state.page+1);
  let params = buildSearchAndFiltersParams(state);

  commit('SET_LOADING', false);

  return reservationAPI.fetchReservations(params).then(reservations => {

    if(reservations.count!=null){
      commit('UPDATE_RESERVATIONS', reservations.list);
      commit('SET_COUNT', reservations.count );

      commit('SET_PAGES', reservations.pages );
    }

    commit('SET_LOADING', false);
  });

}

const fetchReservations = function({commit, state}){
  if(state.outDated){
    // commit('SET_LOADING', true);

    let params = buildSearchAndFiltersParams(state);
    commit('SET_LOADING', true);
    return reservationAPI.fetchReservations(params).then(reservations => {
      commit('SET_RESERVATIONS', reservations.list);
      if(reservations.count){
        commit('SET_COUNT', reservations.count );
        commit('SET_PAGES', reservations.pages );
        commit('SET_PAGE', reservations.page);
      }else{
        commit('SET_COUNT', 0 );
      }
      commit('SET_LOADING', false);
    });
  }

}

const fetchReservation = function({commit, state}, reservationId){
  commit('SET_LOADING', true);
  return reservationAPI.getReservation(reservationId)
    .then(reservation=>{
        commit('SET_SELECTED_RESERVATION_BY_ID', reservation);
        commit('SET_LOADING', false);
    })
}

const fetchCustomerReservations = function({commit,state},customerId){
  commit('SET_LOADING', true);
  let params ={};
  params.customerId = customerId;
  params.paging='no';
  params.orderBy='created_at';
  params.direction='ASC';

  return reservationAPI.fetchReservations(params).then(reservations => {
    commit('SET_CUSTOMER_RESERVATIONS', reservations);
    commit('SET_LOADING', false);
  });
}


const deleteSelectedReservation = function ({commit, state, dispatch}){

  if(state.selectedReservation.sales_order!=null){
    Message.error({message : "Impossible de supprimer la réservation, car elle est présente dans une commande."})
  }else{
    commit('SET_LOADING', true);
    return reservationAPI.deleteReservation(state.selectedReservation.id)
      .then(()=>{
          commit('DELETE_SELECTED_RESERVATION');
          commit('SET_LOADING', false);
          dispatch('stockItems/invalidateStockItems',null,{root:true});
      }).catch(err=>{
        commit('SET_LOADING', false);
      })
  }

}

const deleteCustomerReservation = function ({commit, state, dispatch}, {customerId,reservationId}){
  commit('SET_LOADING', true);

  return reservationAPI.deleteReservation(reservationId)
    .then(()=>{
        dispatch('fetchCustomerReservations', customerId);
    }).catch(err=>{
      commit('SET_LOADING', false);
    })
}

const selectReservation = function({commit,state, dispatch},{index, reservationId}){
  if(index!=null){
    commit('SET_SELECTED_RESERVATION', index);
  }else{
    dispatch('fetchReservation',reservationId);
  }
  commit('SET_ACTIVE_TAB', 'overview');
}

const invalidateReservationList = function ({ commit }) {
  commit('SET_PAGE',1);
  commit('INVALIDATE_LIST');
}

const changePage = function({commit, dispatch}, page) {
  commit('SET_PAGE', page);
  dispatch('invalidateReservationList');
  dispatch('fetchReservations')
}

const changeOrderBy = function({commit, state, dispatch}, {orderName, direction}){
  commit('SET_ORDERNAME_AND_DIRECTION', {orderName, direction});
  dispatch('invalidateReservationList');
  dispatch('fetchReservations');
}
const changeSortIcon = function({commit},icon){
  commit('SET_SORT_ICON',icon);
}

let searchTimeOut = null;
const setSearchTerms = function({commit, dispatch}, searchTerms) {
  commit('SET_SEARCH_TERMS',searchTerms);
  commit('SET_LOADING', true);
  clearTimeout(searchTimeOut)
  searchTimeOut = setTimeout(() => {
    dispatch('invalidateReservationList');
    dispatch('fetchReservations');
  }, 300)
}

const updateSelecteReservation = function({commit, state}, reservation){
  commit('UPDATE_SELECTED_RESERVATION', reservation);
}

const setActiveTab = function({commit, dispatch}, activeTab){
  commit('SET_ACTIVE_TAB', activeTab);
  // dispatch('invalidateReservationList');
  // dispatch('fetchReservations')
}

const setFilterActive = function({commit, dispatch}, active){
  commit('SET_FILTER_ACTIVE', active);
  dispatch('invalidateReservationList');
  dispatch('fetchReservations')
}

const setFilterIntent = function({commit, dispatch}, intent){
  commit('SET_FILTER_INTENT', intent);
  dispatch('invalidateReservationList');
  dispatch('fetchReservations')
}

const setFilterCompleted = function({commit, dispatch}, completed){
  commit('SET_FILTER_COMPLETED', completed);
  dispatch('invalidateReservationList');
  dispatch('fetchReservations')
}

const setFilterInactive = function({commit, dispatch}, inactive){
  commit('SET_FILTER_INACTIVE', inactive);
  dispatch('invalidateReservationList');
  dispatch('fetchReservations')
}

const setFilterRedFlag = function({commit, dispatch}, redFlag){
  commit('SET_FILTER_RED_FLAG', redFlag);
  dispatch('invalidateReservationList');
  dispatch('fetchReservations')
}
const setFilterYellowFlag = function({commit, dispatch}, yellowFlag){
  commit('SET_FILTER_YELLOW_FLAG', yellowFlag);
  dispatch('invalidateReservationList');
  dispatch('fetchReservations')
}
const setFilterGreenFlag = function({commit, dispatch}, greenFlag){
  commit('SET_FILTER_GREEN_FLAG', greenFlag);
  dispatch('invalidateReservationList');
  dispatch('fetchReservations')
}
const setFilterSalesRep = function({commit, dispatch}, salesRep){
  commit('SET_FILTER_SALES_REP', salesRep);
  dispatch('invalidateReservationList');
  dispatch('fetchReservations')
}

const setFilterDelayed = function({commit, dispatch}, delayed){
  commit('SET_FILTER_DELAYED', delayed);
  dispatch('invalidateReservationList');
  dispatch('fetchReservations')
}

const setCustomerFilter = function({commit, dispatch}, customer){
  commit('SET_FILTER_CUSTOMER_ID', customer.id);
  dispatch('invalidateReservationList');
  dispatch('fetchReservations')
}

const setInventoryFilter = function({commit, dispatch}, inventories){
  commit('SET_FILTER_INVENTORIES', inventories);
  dispatch('invalidateReservationList');
  dispatch('fetchReservations')
}

const setProductFilter = function({commit, dispatch}, product){
  commit('SET_FILTER_PRODUCT_ID', product.id);
  dispatch('invalidateReservationList');
  dispatch('fetchReservations')
}


const resetFilters = function({commit, dispatch}){
  commit('RESET_FILTERS');
  dispatch('invalidateReservationList');
  dispatch('fetchReservations')
}

const changeMode = function({commit}, mode){
  commit('SET_MODE',mode);
}

const changeCustomerClassFilter = function({commit, dispatch}, checkedCustomerClasses){
  commit('CHANGE_CHECKED_CUSTOMER_CLASSES_FILTER', checkedCustomerClasses);
  dispatch('invalidateReservationList');
  dispatch('fetchReservations');
}

export default {
  fetchNextReservationsPage,
  fetchReservations,
  fetchReservation,
  fetchCustomerReservations,
  deleteSelectedReservation,
  deleteCustomerReservation,
  invalidateReservationList,
  changeOrderBy,
  changeSortIcon,
  setSearchTerms,
  selectReservation,
  changePage,
  updateSelecteReservation,
  setActiveTab,
  setFilterActive,
  setFilterInactive,
  setFilterRedFlag,
  setFilterYellowFlag,
  setFilterGreenFlag,
  setFilterSalesRep,
  setFilterDelayed,
  resetFilters,
  changeMode,
  setCustomerFilter,
  setProductFilter,
  setFilterCompleted,
  setFilterIntent,
  setInventoryFilter,
  changeCustomerClassFilter,
  getQueryParams,
};
